import { request } from '@blade/common';
import { dateFormat } from '@blade/common/utils/filters';
import { useLocal } from '.';
import { PageOrderEnum } from '@blade-sxp/portrait-management/interfaces/common';
let list = [];
for (let i = 0; i < 20; i++) {
    if (useLocal) {
        addPortrait({
            images: ['https://t11.baidu.com/it/u=1413379684,507496555&fm=58'],
            name: 'Donald Trump ' + i,
            libIds: [i],
            gender: 'Male',
            country: 'USA',
            birthDay: '1946-06-14',
            phone: 'xxx-xxxxx',
            email: 'trump@fakenews.com',
            department: 'xxx',
            entryTime: '2017-01-20',
            identityId: 'xxxxxxxx',
            identityType: 'xxx',
            workId: 'xxxx',
            externalBizId: 'xxxx',
            icCard: 'xxxx',
            remark: 'xxxxx',
            validateEndDate: '',
            validateType: ''
        });
    }
}
export function updatePortrait(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portrait/update/portrait/${data.portraitId}`,
            method: 'PUT',
            data,
        });
    }
    return new Promise((resolve) => {
        const result = list.find(p => p.portraitId === data.portraitId);
        if (result) {
            for (const key in result) {
                result[key] = data[key];
            }
        }
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function deletePortraitRelation(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portrait/delete`,
            method: 'DELETE',
            data
        });
    }
    return new Promise((resolve, reject) => {
        list = list.filter(a => a.relationId !== data.relationId);
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
export function batchDeletePortraits(data) {
    if (!useLocal) {
        return request({
            url: '/api/portrait-management/api/v1/portrait/batch/delete',
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve, reject) => {
        list = list.filter(a => !data.relationIds.includes(Number(a?.portraitId)));
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
export function queryPortraitDetail(portraitId) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portrait/${portraitId}`,
            method: 'GET',
        });
    }
    return new Promise((resolve, reject) => {
        const result = list.find(a => Number(a?.portraitId) === portraitId);
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function addPortrait(data) {
    if (!useLocal) {
        return request({
            url: '/api/portrait-management/api/v1/portrait/add',
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve) => {
        const result = {
            ...data,
            portraitId: Math.random() * 100000000,
            relationId: Math.random() * 100000000,
            createBy: 'lrf',
            updateBy: 'lrf',
            libId: 1,
            image: data.images[0],
            libName: 'Portrait Library Name Too Long',
            libs: [{
                    libId: 1,
                    name: 'Portrait Library Name Too Long'
                }],
            updateTime: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
        };
        list.push(result);
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function queryPortraitLibPageList(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portrait/page/query`,
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve) => {
        // 先过滤
        let tmp = list.filter(a => !data.keywords || a.name.includes(data.keywords) || a.portraitId?.toString()?.includes(data.keywords));
        // 再排序
        if (data.pageOrderList) {
            for (const orderList of data.pageOrderList) {
                if (orderList.orderField === 'updateTime') {
                    tmp = tmp.sort((a, b) => {
                        if (orderList.orderType === PageOrderEnum.ASC)
                            return +new Date(a.updateTime) - +new Date(b.updateTime);
                        return +new Date(b.updateTime) - +new Date(a.updateTime);
                    });
                }
            }
        }
        // 再分页
        const page = data.page ?? 1;
        const size = data.size ?? 10;
        const result = {
            page,
            size,
            total: tmp.length,
            totalPage: parseInt(tmp.length / size + '') + tmp.length % size > 0 ? 1 : 0,
            list: tmp.slice((page - 1) * size, page * size),
            empty: false
        };
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
/** 导出 */
export function portraitExport(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portrait/export`,
            method: 'POST',
            data
        });
    }
}
// --- 批量导入相关 --- start ---
// 获取筛选项
export function getImportOption(data) {
    return request({
        url: `/api/portrait-management/api/v1/portraitlib/list`,
        method: 'POST',
        data
    });
}
// 批量上传
export function setBatchImport(data) {
    return request({
        url: `/api/portrait-management/api/v1/batch/task`,
        method: 'POST',
        data
    });
}
// 获取 table 列表
export function getImportList(data) {
    return request({
        url: `/api/portrait-management/api/v1/batch/tasks`,
        method: 'POST',
        data
    });
}
// 重新上传
export function againUpload(taskId) {
    return request({
        url: `/api/portrait-management/api/v1/batch/task/retry/${taskId}`,
        method: 'GET'
    });
}
// 获取上传详情的上方info
export function getRecordInfo(task_id) {
    return request({
        url: `/api/portrait-management/api/v1/batch/task/${task_id}`,
        method: 'GET'
    });
}
// 获取上传详情的tableList
export function getRecordList(data) {
    return request({
        url: `/api/portrait-management/api/v1/batch/task/images`,
        method: 'POST',
        data
    });
}
// 生成通行码
export const generatePassCodeApi = (data) => request.post('/api/portrait-management/api/v1/portrait/generateQrCode', data);
// 获取通行码详情
export const getPassCodeApi = (portraitId) => request.get(`/api/portrait-management/api/v1/portrait/qrCode/${portraitId}`);
